import styled from 'styled-components';

import ColorConstants from '@shared/constants/ColorConstants';
import { FlexDiv } from '@shared/components/base/Div';
import { Label, Title } from '@shared/components/base/Text';

export const StyledLabel = styled(Label)`
    color: ${ColorConstants['iris-blue']};
    padding: 4px 7px 0px 0px;
`;

export const MenuContainer = styled(FlexDiv)`
    justify-content: space-between;
    padding: 20px 36px;
    height: 78px;
`;

export const RightMenu = styled(FlexDiv)`
    justify-content: space-around;
    padding-top: 8px;
`;

export const ChildrenWrapper = styled.div`
    background-color: ${ColorConstants.white};
    height: auto;
`;

export const StyledTitle = styled(Title)`
    font-size: 15px;
    height: 40px;
    line-height: 40px;
     ${({ styles }) => styles && { ...styles }};
`;
